<script>
    import R, {LOADER} from "../lib/requests";
    import charges from "../stores/charges";
    import {OBJECTS} from "../lib/constants";
    import {formatDate, sort} from "../lib/lib";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import ChargeIcon from "../components/icons/ChargeIcon.svelte";
    import SubscriptionEditModal from "./SubscriptionEditModal.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";


    export let serviceId;
    export let service;

    let editId = null;

    const tableColumns = [
        {key: 'start_at', title: 'ΕΝΑΡΞΗ', sortable: true},
        {key: 'end_at', title: 'ΛΗΞΗ', sortable: true},
        {key: 'price', title: 'ΤΙΜΗ', sortable: true},
        {key: '', title: ''},
        {key: '', title: ''},
    ];

    const sortList = ({detail:column}) => {
        service.subscriptions = sort(service.subscriptions, column.key, column.sort_way === 'ASC');
    }

    const load = () => {

        const onSuccess = result => {
            service.subscriptions = result;
        }

        const onFailure = err => {
        };

        R.handle(R.service.subscriptions, serviceId, onSuccess, onFailure, LOADER.POPUP);
    };

    const onEdit = (entry) => {
        editId = entry.id;
    }

    const closeEdit = param => {
        editId = null;

        if (param) {
            let item = service.subscriptions.find(x => x.id === param.id);
            if (item) {
                Object.keys(item).map(key => {
                    if (param[key]) {
                        item[key] = param[key];
                    }
                })
            }
            service.subscriptions = service.subscriptions;
        }
    }


    const onDelete = (entity) => {
        Alert.delete("Διαγραφή", `Να διαγραφεί η συνδρομή από την υπηρεσία;`, () => deleteEntity(entity.id));
    }

    const deleteEntity = (id) => {

        const onSuccess = result => {
            service.subscriptions = service.subscriptions.filter(x => x.id != result);
            Notifier.showMessage("Η συνδρομή διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.service.deleteSubscription, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onCharge = obj => {
        console.log(service);
        if (!obj.charge_id) {
            let name = `${service.ws_service ? service.ws_service.name : 'Ανανέωση'} ${service.name} (${formatDate(obj.start_at, 'd/m/y')} - ${formatDate(obj.end_at, 'd/m/y')})`;
            charges.create(OBJECTS.SUBSCRIPTION, obj.id, {name}, closeCharge);
        } else {
            charges.edit(obj.charge_id, closeCharge);
        }
    }

    const closeCharge = (param) => {
        if (!param) {
            return;
        }
        let item = service.subscriptions.find(x => x.id == param.object_id);
        if (item) {
            item.charge_id = param.id;
            service.subscriptions = service.subscriptions;
        }
    }

    load();
</script>

{#if service.subscriptions}
    {#if service.subscriptions.length}
        <table class="table table-list table-list-border">
            <TableHeader {tableColumns} on:sort={sortList}/>
            <tbody>
            {#each service.subscriptions as item}
                <tr>
                    <td class="date-column pad-sm">
                        <button class="btn-reset is-link" on:click={() => onEdit(item)}>
                            { formatDate(item.start_at, 'd-m-y') }
                        </button>
                    </td>
                    <td class="date-column pad-sm">
                        { formatDate(item.end_at, 'd-m-y') }
                    </td>
                    <td class="price-column text-gray pad-sm text-end">
                        { item.price || '' }
                    </td>
                    <td class="button-column">
                        <button class="button" title="χρέωση"
                                on:click={ () => onCharge(item) }>
                            <ChargeIcon active="{ item.charge_id }"/>
                        </button>
                    </td>
                    <td class="button-column">
                        <button class="button" title="διαγραφή" on:click={ () => onDelete(item) }>
                            <AppIcon icon="trash"/>
                        </button>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        Δεν υπάρχουν συνδρομές!
    {/if}
{/if}

{#if editId != null}
    <SubscriptionEditModal subscriptionId={editId} closeCallback={closeEdit}/>
{/if}
